module.exports = __webpack_public_path__ + "static/media/mtn-wallet.82b32dd3.svg";